import React from 'react';
import { colors } from '../../../../styles/Colors';
import { Label, TextBold, TextMedium } from '../../../../styles/GlobalStyledComponents';
import { CardCheckbox, CardColumn, CardInfoSection, CardLabel, InfoCardMiniSpan } from '../../../CardInputs/CardsStyledComponents';
import { CardInputPaymentPlan, CustomAmountTitle, CustomAmountSubtitle, MiniSpanContainer } from '../../ContainerButtons/ContainerButtonsStyledComponents';
import PaymentPlan from './Detail/PaymentCard';
import { CardCustomPaymentSection } from './Detail/PaymentCardStyledComponents';
import { SimulationData } from '../../../../interfaces/PaymentPlan';
import { CoCheckboxContainer } from '../../../../pages/EntryCO/EntryCOStyledComponents';


interface PlanPaymentCardProps {
    isPaymentPlan: boolean;
    totalDebtAmount: number;
    simulationData: SimulationData[];
    onSelectInputPlan: () => void;
    handleMonthDay: (value: number) => void;
    calculateNewSimulation: (value: number) => void;
}

const PlanPaymentCard: React.FC<PlanPaymentCardProps> = ({
    totalDebtAmount,
    isPaymentPlan,
    simulationData,
    onSelectInputPlan,
    handleMonthDay,
    calculateNewSimulation,
}) => {
    return (
        <CardInputPaymentPlan
            onClick={onSelectInputPlan}
            selected={isPaymentPlan}
            borderColor={colors.red7}
            cardPadding="24px"
            id="co-payment-plan-card-input"
        >
            <CardCustomPaymentSection
                id="co-payment-plan-custom-card-section"
            >
                <CoCheckboxContainer
                    onClick={onSelectInputPlan}
                    id="co-payment-plan-checkbox-container"
                >
                    <CardCheckbox
                        type="radio"
                        checked={isPaymentPlan}
                        readOnly
                        id="co-payment-plan-select-radio-btn-checkbox"
                        name="payment-checkbox"
                    />
                    <Label htmlFor="co-payment-plan-select-radio-btn-checkbox"></Label>
                </CoCheckboxContainer>
                <CardInfoSection id="co-payment-plan-card-section">
                    <CardColumn id="co-payment-plan-card-column">
                        <CustomAmountTitle id="co-payment-plan-card-title">
                            <TextBold fontSize={16} lineHeight={22}>
                                Crea tu plan de pagos
                            </TextBold>
                        </CustomAmountTitle>
                        <CustomAmountSubtitle id="co-payment-plan-card-subtitle">
                            <TextMedium fontSize={14} color={'gray6'} lineHeight={20}>
                                Diseña el plan de pagos que mejor se adapte a tus necesidades
                            </TextMedium>
                        </CustomAmountSubtitle>
                    </CardColumn>
                </CardInfoSection>
            </CardCustomPaymentSection>
            <MiniSpanContainer id="co-info-card-mini-span-container">
                <InfoCardMiniSpan id="co-info-text" backgroundColor={colors.yellow10}>
                    <CardLabel fontSize={14} lineHeight={16}>
                        A tu medida
                    </CardLabel>
                </InfoCardMiniSpan>
            </MiniSpanContainer>
            {isPaymentPlan && (
                <PaymentPlan
                    totalDebtAmount={totalDebtAmount}
                    simulationData={simulationData}
                    handleMonthDaySelected={handleMonthDay}
                    calculateNewSimulation={calculateNewSimulation}
                />
            )}
        </CardInputPaymentPlan>
    );
};

export default PlanPaymentCard;